<template>
  <b-modal
    id="payroll-sign-up"
    ref="payroll-sign-up"
    size="payroll"
    modal-class="payroll-sing-up-modal"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div v-if="showGetEarlyAccess">
      <h4>Sign Up for Early Access</h4>
      <p>
        Unlock early access to Atto&apos;s new payroll features!<br /> Join our
        limited release and transform the<br /> way you do payroll.
      </p>
      <form method="post" autocomplete="off" @submit.prevent="handleSubmit">
        <div class="form-group">
          <label>How many employees are on your payroll?</label>

          <select-dropdown-component
            :options="employeesOptions"
            :value="employees_on_payroll"
            placeholder="Select an option"
            @onOptionSelected="onEmployeesSelected"
          />
        </div>
        <div class="form-group">
          <label>
            Which payroll service, if any, are you currently using?
          </label>
          <select-dropdown-component
            :value="current_payroll_service"
            placeholder="Select an option"
            :options="payrollOptions"
            @onOptionSelected="onPayrollOptionSelected"
          />
        </div>
        <div class="form-group">
          <label>When is your target date for a new payroll system?</label>
          <simple-datepicker-component
            :initial-date="target_date"
            :date-format="'MMMM D, YYYY'"
            :close-on-select="true"
            @onDateSelected="onDateSelected"
          />
        </div>
        <div
            v-if="hasError"
            class="error-wrapper"
        >
        <span class="error-message">
          {{label.get('please_fill_the_blank_fields')}}
        </span>
        </div>
        <div class="modal-footer">
          <Button
            class="atto-btn black-btn"
            type="submit"
          >
            Sign Up for Early Access
          </Button>
          <Button
            class="cancel-btn"
            type="submit"
            @click="close"
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>

    <div v-if="showSignupConfig">
      <h4>Thanks for Signing Up!</h4>
      <p>
        Your request has been successfully submitted. We appreciate your
        interest in our payroll solution and will reach out shortly with
        further details. Stay tuned!
      </p>
      <div class="modal-footer">
        <Button
          class="atto-btn black-btn"
          type="submit"
          @click="close"
        >
          Continue
        </Button>
      </div>
    </div>

  </b-modal>
</template>

<script>

import SelectDropdownComponent from "../../../shared/components/SelectDropdownComponent";
import SimpleDatepickerComponent from "../../../shared/components/SimpleDatepickerComponent";
import PayrollService from "../shared/PayrollService";

export default {
  name: "PayrollSignUpComponent",
  components: {SimpleDatepickerComponent, SelectDropdownComponent},
  props: {
    activity: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data(){
    return{
      payrollOptions: [
        { value: "In-house payroll", label: "In-house payroll" },
        { value: "Not currently using a payroll service", label: "Not currently using a payroll service" },
        { value: "ADP", label: "ADP" },
        { value: "Paychex", label: "Paychex" },
        { value: "Gusto", label: "Gusto" },
        { value: "QuickBooks", label: "QuickBooks" },
        { value: "SurePayroll", label: "SurePayroll" },
        { value: "Square Payroll", label: "Square Payroll" },
        { value: "Wave Payroll", label: "Wave Payroll" },
        { value: "Zenefits", label: "Zenefits" },
        { value: "OnPay", label: "OnPay" },
        { value: "Paycor", label: "Paycor" },
        { value: "Patriot Software", label: "Patriot Software" },
        { value: "Rippling", label: "Rippling" },
        { value: "Sage Payroll", label: "Sage Payroll" },
        { value: "Prime Pay", label: "Prime Pay" },
        { value: "Paylocity", label: "Paylocity" },
        { value: "Other", label: "Other" },
      ],
      employeesOptions: [
        { value: "1 - 10" , label: "1 - 10" },
        { value: "11 - 25", label: "11 - 25" },
        { value: "26 - 50", label: "26 - 50" },
        { value: "51 - 99", label: "51 - 99" },
        { value: "100+", label: "100+" },
      ],
      employees_on_payroll: null,
      current_payroll_service: null,
      target_date: null,
      showGetEarlyAccess: true,
      showSignupConfig: false,
      hasError: false
    }
  },
  mounted() {
    this.$refs['payroll-sign-up'].show();
  },
  methods: {
    getEarlyAccess() {
      this.showGetEarlyAccess = true;
    },
    close(){
      this.$root.$emit('hideGetEarlyAccessModal');
    },
    onEmployeesSelected(selectedOption) {
      this.employees_on_payroll = selectedOption;

      console.log("employees_on_payroll:", this.employees_on_payroll.value);
    },
    onPayrollOptionSelected(selectedOption) {
      this.current_payroll_service = selectedOption;
      console.log("current_payroll_service:", this.current_payroll_service.value);
    },
    onDateSelected(date) {
      if (date === undefined || date === null) {
        return;
      }

      this.target_date = date;
    },
    handleSubmit() {
      this.showSignupConfig = false;

      if (this.employees_on_payroll === null || this.current_payroll_service === null || this.target_date === null) {
        this.hasError = true;
        return false;
      }

      const data = {
        employees_on_payroll: this.employees_on_payroll.value,
        current_payroll_service: this.current_payroll_service.value,
        target_date: this.target_date,
      }
      PayrollService.payrollEarlyAccess(data)
          .then((result) => {
            this.employees_on_payroll = data.employees_on_payroll;
            this.current_payroll_service = data.current_payroll_service;
            this.target_date = data.target_date;
            this.showGetEarlyAccess = false;
            this.showSignupConfig = true;
          })
          .catch(error => {
            this.showSignupConfig = false;
          })
    }
  }
}
</script>
<style lang="scss">
.payroll-sing-up-modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;
  .modal-payroll{
    max-width: 560px;
  }
  .modal-content {
    position: relative;
    background-color: #ffffff;
    padding: 80px 80px 60px;
    border-radius: 20px;
    max-width: 560px;
    width: 100%;
    box-sizing: border-box;
    flex-flow: column;

  /*  @media (max-width: 1200px) {
      width: 90%;
    }*/

    .content-holder{
      display: flex;
      flex-flow: row;
      justify-content: space-between;
      align-items: flex-start;
      margin: 0;
      padding: 0;
      max-width: 100%;
    }
    h4{
      font-weight: $roboto-bold;
      font-family: $roboto-font;
      font-size: 32px;
      line-height: 28px;
      letter-spacing: 0;
      color: #000000;
      margin-bottom: 20px;
    }
    p{
      font-weight: $roboto-regular;
      font-family: $roboto-font;
      font-size: 16px;
      line-height: 20px;
      color: #000000;
      letter-spacing: 0;
      max-width: 355px;
      width: 100%;
      margin: 0 0 20px 0;
    }
    form{
      width: 100%;
      display: flex;
      flex-flow: column;
      .form-group{
        width: 100%;
        label{
          color: #666666;
          font-family: $roboto-font;
          font-weight: $roboto-regular;
          font-size: 13px;
          line-height: 20px;
          letter-spacing: 0;
          margin: 0 0 4px 0;
          width: 100%;
        }
      }
      .flatpickr-mask{
        height: 50px;
        display: flex;
        align-items: center;
        background-image: url("~@assets/images/calendar_icon_black.svg");
        background-size: 18px;
        background-repeat: no-repeat;
        background-position: right 19px center;
        border-radius: 4px;
        padding-left: 16px;
        padding-right: 16px;
        span.mask-content.placeholder{
          align-items: center;
          display: flex;
          color: $atto-white;
          &:before{
            content: "Select date";
            display: flex;
            color: #666666;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.25rem;
          }
        }
      }

      .atto-select{
        height: 50px;

        .select-heading {
          height: 50px;
          border-radius: 4px;
          box-sizing: border-box;
          padding-left: 16px;
          padding-right: 16px;
          span{
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.25rem;
            color: #666666;
            &.selected{
              color: $atto-font-color;
            }
          }
          i{
            color: #000000;
            font-weight: 600;
          }
        }
        &.opened{
          .select-options{
            top: 0;
          }
        }
      }
      .select-options{
        .heading{
          span{
            font-weight: 400;
            color: #666666;
            font-size: 1rem;
            line-height: 1.25rem;
          }
          i{
            color: #000000;
            font-weight: 600;
          }
        }
      }



    }
    .modal-footer{
      display: flex;
      width: 100%;
      padding: 0;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      margin-top: 40px;
      button{
        width: 100%;
        max-width: 100%;
        height: 50px;
        margin: 0;
        align-items: center;
        font-size: 18px;
        line-height: 20px;
        text-transform: capitalize;
        &.atto-btn{
          &.black-btn{
            background-color: #000000;

            &:hover{
            background-color: #262626;
          }
          }
        }

        &.cancel-btn{
          max-width: 204px;
          height: 24px;
          margin-top: 30px;
        }
      }
    }
  }
}


</style>